global.modules.set({
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    $(document).on('click', '.show_order_details', function () {
      var button = $(this);
      var elem = button.closest('.order')
      const data = button.data();
      if (!elem.find('.order-card-details').children().length) {
        $.ajax({
          url: '/orders/details/' + data.type,
          data: JSON.stringify({ id: data.id }),
          method: 'POST',
          contentType: 'application/json',
          accepts: {
            html: "text/html",
          }, 
          elem,
          success: function (response) {
            if(!response) {
              global.showNotificationPopup('Some error occured', 'error');
              return;
            }
            $(response).appendTo(elem.find('.order-card-details'));
            elem.find('.order-card-details').show();
            button.replaceWith(`
            <button type="button" class="hide_order_details text-matterhorn fs-9 fs-lg-8 p-0 lh-sm font-RobotoMedium hoverable text-hover-summerSky">Hide details</button>
            `);
          }
        })
      } else {
        elem.find('.order-card-details').show();
        button.replaceWith(`
        <button type="button" class="hide_order_details text-matterhorn fs-9 fs-lg-8 p-0 lh-sm font-RobotoMedium hoverable text-hover-summerSky">Hide details</button>
        `);
      }
    });

    $(document).on('click', '.hide_order_details', function () {
      var button = $(this);
      var elem = button.closest('.order');
      elem.find('.order-card-details').hide();
      button.replaceWith(`
        <button type="button" class="show_order_details text-matterhorn fs-9 fs-lg-8 p-0 lh-sm font-RobotoMedium hoverable text-hover-summerSky">Show more details</button>
      `);
    });
  }
})

